import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Logo } from "@/components/Logo";
import { assetUrl } from "@/lib/api";

const NAV = [
  { label: "Beranda", href: "#beranda" },
  { label: "Tentang Kami", href: "#tentang-kami" },
  { label: "Harga", href: "#harga" },
  { label: "Testimoni", href: "#testimoni" },
  { label: "Galeri", href: "#galeri" },
  { label: "Lokasi", href: "#lokasi" },
];

export const Header = ({ content }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const wa = `https://wa.me/${content.contact.whatsapp}`;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="header-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-white/80 backdrop-blur-xl border-b border-slate-200/60 shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
        <div className="flex items-center justify-between h-20">
          <a href="#beranda" data-testid="logo-link" className="group">
            <span className="group-hover:scale-[1.03] transition-transform inline-block">
              <Logo size={44} light={!scrolled} logoUrl={assetUrl(content.brand.logo)} />
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-1">
            {NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                data-testid={`nav-${item.label.toLowerCase().replace(/\s/g, "-")}`}
                className={`px-4 py-2 rounded-lg text-sm font-semibold transition-colors ${
                  scrolled
                    ? "text-slate-600 hover:text-sky-600 hover:bg-sky-50"
                    : "text-white/90 hover:text-white hover:bg-white/10"
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          <a
            href={wa}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-cta-button"
            className="hidden lg:inline-flex items-center px-5 py-2.5 rounded-full bg-sky-500 hover:bg-sky-600 text-white text-sm font-semibold shadow-lg shadow-sky-500/30 hover:-translate-y-0.5 transition-all"
          >
            Hubungi Kami
          </a>

          <button
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-toggle"
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-lg ${
              scrolled ? "text-slate-700 hover:bg-sky-50" : "text-white hover:bg-white/10"
            }`}
            aria-label="Buka menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-white/95 backdrop-blur-xl border-t border-slate-200 px-6 py-4">
          <nav className="flex flex-col gap-1">
            {NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="px-4 py-3 rounded-lg text-base font-semibold text-slate-700 hover:bg-sky-50"
              >
                {item.label}
              </a>
            ))}
            <a
              href={wa}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setOpen(false)}
              className="mt-2 text-center px-5 py-3 rounded-full bg-sky-500 text-white font-semibold"
            >
              Hubungi Kami
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};
